import { h, defineComponent, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { clipping_model_editable, clipping_on } from '@features/clipping';
import flatten_svg from '../../../assets/img/SVG_icons/Top/editing_model/flatten_face.svg';
import { img } from '@phi/components';
import { uil_flatten_objects } from '@frontend/ui_logic';
import FlattenTooltip from './FlattenTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const FlattenIcon = flatten_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Flatten';
        },

        disabled() {
            return !this.state.loaded
                || this.state.editing_reference_sketches
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_stl
                || this.state.rigid_move_manipulator
                || (
                    clipping_on.value
                    && !clipping_model_editable.value
                )
                || (
                    this.state.selected_edges_count
                    + this.state.selected_faces_count
                ) === 0;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                uil_flatten_objects();
        },
    },

    render() {
        return h(BarButton, {
            id: 'flatten-face-button',
            wrapperId: 'flatten-face-wrapper',
            tippy: 'bottom',
            onClick: this.onClick,
            disabled: this.disabled,
            active: false,
            selected: this.state.tut_stage === 7,
            help: 'flatten',
        }, {
            label: () => 'Flatten',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(flatten_svg, this.alt),
            tooltip: FlattenTooltip,
        });
    }
});
